import { imprimirModulo } from '../utils/funciones';
import ModalModulos from '../components/ModalModulos.vue';

export default {
  components: {
    ModalModulos,
  },
  computed: {
    textoProgramaModulo() {
      if (!this.programaModuloMasAlto) {
        return '-';
      }

      return `N° ${this.programaModuloMasAlto?.numero}`;
    },
    tituloProgramaModulo() {
      const programaModuloTexto = imprimirModulo(this.programaModuloMasAlto);

      return programaModuloTexto;
    },
  },
  methods: {
    mostrarModal() {
      this.$refs.modalModulosInscritosRef.abrir();
    },
  },
};
